var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.015 260.788C500.015 239.812 498.313 224.505 494.63 208.631H255.1V303.308H395.698C392.865 326.836 377.558 362.27 343.541 386.08L343.064 389.25L418.799 447.921L424.046 448.444C472.235 403.939 500.015 338.458 500.015 260.788Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.108 510.238C323.989 510.238 381.816 487.56 424.054 448.443L343.549 386.078C322.006 401.102 293.091 411.59 255.108 411.59C187.643 411.59 130.383 367.088 109.971 305.575L106.979 305.829L28.2291 366.775L27.1992 369.638C69.152 452.976 155.326 510.238 255.108 510.238Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.984 305.577C104.598 289.703 101.482 272.693 101.482 255.119C101.482 237.543 104.598 220.536 109.701 204.662L109.558 201.281L29.8211 139.356L27.2122 140.597C9.92147 175.181 0 214.017 0 255.119C0 296.222 9.92147 335.056 27.2122 369.639L109.984 305.577Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.108 98.646C303.013 98.646 335.327 119.339 353.754 136.632L425.754 66.3314C381.534 25.2287 323.989 0 255.108 0C155.326 0 69.152 57.26 27.1992 140.599L109.688 204.663C130.383 143.151 187.643 98.646 255.108 98.646Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.3e061e123384e5fb17da841362226df0.svg";
export { ForwardRef as ReactComponent };